"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fbo_1 = __importDefault(require("./gl-utils/fbo"));
var gl_canvas_1 = require("./gl-utils/gl-canvas");
var gl_resource_1 = __importDefault(require("./gl-utils/gl-resource"));
var ShaderManager = __importStar(require("./gl-utils/shader-manager"));
var vbo_1 = __importDefault(require("./gl-utils/vbo"));
var parameters_1 = __importDefault(require("./parameters"));
require("./page-interface-generated");
var Automaton2D = (function (_super) {
    __extends(Automaton2D, _super);
    function Automaton2D() {
        var _this = _super.call(this, gl_canvas_1.gl) || this;
        _this._FBO = new fbo_1.default(gl_canvas_1.gl, 512, 512);
        _this._vbo = vbo_1.default.createQuad(gl_canvas_1.gl, -1, -1, 1, 1);
        var initializeTexturesForCanvas = function () {
            var canvasSize = Page.Canvas.getSize();
            _this.initializeTextures(canvasSize[0], canvasSize[1]);
            _this.recomputeVisibleSubTexture();
        };
        _this._needToRecomputeShader = true;
        _this._mustClear = true;
        _this._textures = [null, null];
        _this._visibleSubTexture = [0, 0, 1, 1];
        initializeTexturesForCanvas();
        Page.Canvas.Observers.mouseDrag.push(function (dX, dY) {
            _this._visibleSubTexture[0] -= dX * _this._visibleSubTexture[2];
            _this._visibleSubTexture[1] -= dY * _this._visibleSubTexture[3];
            _this.recomputeVisibleSubTexture();
            _this._needToRedraw = true;
            _this._mustClear = true;
        });
        Page.Canvas.Observers.canvasResize.push(initializeTexturesForCanvas);
        parameters_1.default.resetObservers.push(initializeTexturesForCanvas);
        parameters_1.default.rulesObservers.push(function () { return _this._needToRecomputeShader = true; });
        var previousScale = parameters_1.default.scale;
        parameters_1.default.scaleObservers.push(function (newScale, zoomCenter) {
            _this._needToRedraw = true;
            _this._mustClear = true;
            _this._visibleSubTexture[0] += zoomCenter[0] * (1 - previousScale / newScale) * _this._visibleSubTexture[2];
            _this._visibleSubTexture[1] += zoomCenter[1] * (1 - previousScale / newScale) * _this._visibleSubTexture[3];
            previousScale = newScale;
            _this.recomputeVisibleSubTexture();
        });
        ShaderManager.buildShader({
            fragmentFilename: "display-2D.frag",
            vertexFilename: "display-2D.vert",
            injected: {},
        }, function (shader) {
            if (shader !== null) {
                _this._displayShader = shader;
                _this._displayShader.a["aCorner"].VBO = _this._vbo;
                _this._displayShader.u["uSubTexture"].value = _this._visibleSubTexture;
            }
        });
        return _this;
    }
    Automaton2D.prototype.freeGLResources = function () {
        if (this._FBO) {
            this._FBO.freeGLResources();
        }
        if (this._vbo) {
            this._vbo.freeGLResources();
            this._vbo = null;
        }
        if (this._displayShader) {
            this._displayShader.freeGLResources();
            this._displayShader = null;
        }
        if (this._updateShader) {
            this._updateShader.freeGLResources();
            this._updateShader = null;
        }
        this.freeTextures();
    };
    Automaton2D.prototype.update = function () {
        if (this._needToRecomputeShader) {
            this.recomputeUpdateShader();
        }
        var shader = this._updateShader;
        if (shader) {
            var current = this._textures[this._currentIndex];
            var next = this._textures[(this._currentIndex + 1) % 2];
            this._FBO.bind([next]);
            shader.u["uPrevious"].value = current;
            shader.u["uPhysicalCellSize"].value = [1 / this._textureSize[0], 1 / this._textureSize[1]];
            shader.use();
            shader.bindUniformsAndAttributes();
            gl_canvas_1.gl.disable(gl_canvas_1.gl.BLEND);
            gl_canvas_1.gl.drawArrays(gl_canvas_1.gl.TRIANGLE_STRIP, 0, 4);
            this._currentIndex = (this._currentIndex + 1) % 2;
            this._iteration++;
        }
    };
    Automaton2D.prototype.draw = function () {
        var shader = this._displayShader;
        if (shader) {
            shader.u["uClearFactor"].value = (this._mustClear) ? 1 : 1 - parameters_1.default.persistence;
            shader.u["uTexture"].value = this._textures[this._currentIndex];
            shader.u["uGridSize"].value = this._gridSize;
            shader.use();
            shader.bindUniformsAndAttributes();
            gl_canvas_1.gl.enable(gl_canvas_1.gl.BLEND);
            gl_canvas_1.gl.drawArrays(gl_canvas_1.gl.TRIANGLE_STRIP, 0, 4);
            this._needToRedraw = false;
            this._mustClear = false;
        }
    };
    Object.defineProperty(Automaton2D.prototype, "iteration", {
        get: function () {
            return this._iteration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Automaton2D.prototype, "needToRedraw", {
        get: function () {
            return this._needToRedraw;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Automaton2D.prototype, "needToUpdate", {
        get: function () {
            return this._needToRecomputeShader;
        },
        enumerable: false,
        configurable: true
    });
    Automaton2D.prototype.recomputeUpdateShader = function () {
        var _this = this;
        ShaderManager.buildShader({
            fragmentFilename: "update-2D.frag",
            vertexFilename: "update-2D.vert",
            injected: { rules: this.generateShaderRules() },
        }, function (shader) {
            if (shader !== null) {
                if (_this._updateShader) {
                    _this._updateShader.freeGLResources();
                }
                _this._updateShader = shader;
                _this._updateShader.a["aCorner"].VBO = _this._vbo;
            }
        });
        this._needToRecomputeShader = false;
    };
    Automaton2D.prototype.generateShaderRules = function () {
        function generateRuleBlock(starting, ending, rule) {
            if (rule !== "alive") {
                var operation = (rule === "death") ? " -= " : " += ";
                var rangeCheck = void 0;
                if (starting === 0) {
                    rangeCheck = "step(N, " + (ending + .5) + ")";
                    if (ending === 8) {
                        rangeCheck = "1.0";
                    }
                }
                else if (ending === 8) {
                    rangeCheck = "step(" + (starting - .5) + ", N)";
                }
                else {
                    rangeCheck = "step(" + (starting - .5) + ", N) * step(N, " + (ending + .5) + ")";
                }
                return "currentState" + operation + rangeCheck + ";\n";
            }
            return "";
        }
        var result = "";
        var rules = parameters_1.default.rules;
        var currentRule = rules[0];
        var from = 0;
        for (var i = 1; i < 9; ++i) {
            if (rules[i] !== currentRule) {
                result += generateRuleBlock(from, i - 1, currentRule);
                currentRule = rules[i];
                from = i;
            }
        }
        result += generateRuleBlock(from, 8, currentRule);
        return result;
    };
    Automaton2D.prototype.recomputeVisibleSubTexture = function () {
        var canvasSize = Page.Canvas.getSize();
        this._visibleSubTexture[2] = canvasSize[0] / this._gridSize[0] / parameters_1.default.scale;
        this._visibleSubTexture[3] = canvasSize[1] / this._gridSize[1] / parameters_1.default.scale;
        for (var i = 0; i < 2; ++i) {
            this._visibleSubTexture[i] -= Math.min(0, this._visibleSubTexture[i]);
            this._visibleSubTexture[i] -= Math.max(0, this._visibleSubTexture[i] + this._visibleSubTexture[i + 2] - 1);
        }
    };
    Automaton2D.prototype.freeTextures = function () {
        for (var i = 0; i < 2; ++i) {
            if (this._textures[i]) {
                gl_canvas_1.gl.deleteTexture(this._textures[i]);
                this._textures[i] = null;
            }
        }
    };
    Automaton2D.prototype.initializeTextures = function (width, height) {
        function upperPowerOfTwo(n) {
            return Math.pow(2, Math.ceil(Math.log(n) * Math.LOG2E));
        }
        width = upperPowerOfTwo(width);
        height = upperPowerOfTwo(height);
        this._gridSize = [width, height];
        var physicalWidth = width / 4;
        var physicalHeight = height / 4;
        this._FBO.width = physicalWidth;
        this._FBO.height = physicalHeight;
        this._textureSize = [physicalWidth, physicalHeight];
        var data = new Uint8Array(4 * physicalWidth * physicalHeight);
        for (var i = data.length - 1; i >= 0; --i) {
            data[i] = Math.floor(256 * Math.random());
        }
        for (var i = 0; i < 2; ++i) {
            if (this._textures[i] === null) {
                this._textures[i] = gl_canvas_1.gl.createTexture();
            }
            gl_canvas_1.gl.bindTexture(gl_canvas_1.gl.TEXTURE_2D, this._textures[i]);
            gl_canvas_1.gl.texImage2D(gl_canvas_1.gl.TEXTURE_2D, 0, gl_canvas_1.gl.RGBA, physicalWidth, physicalHeight, 0, gl_canvas_1.gl.RGBA, gl_canvas_1.gl.UNSIGNED_BYTE, data);
            gl_canvas_1.gl.texParameteri(gl_canvas_1.gl.TEXTURE_2D, gl_canvas_1.gl.TEXTURE_MAG_FILTER, gl_canvas_1.gl.NEAREST);
            gl_canvas_1.gl.texParameteri(gl_canvas_1.gl.TEXTURE_2D, gl_canvas_1.gl.TEXTURE_MIN_FILTER, gl_canvas_1.gl.NEAREST);
        }
        this._currentIndex = 0;
        this._iteration = 0;
        this._needToRedraw = true;
        Page.Canvas.setIndicatorText("grid-size", width + "x" + height);
    };
    return Automaton2D;
}(gl_resource_1.default));
exports.default = Automaton2D;
